/* eslint-disable react/react-in-jsx-scope */
import { Route, Routes } from "react-router";
// import Login from "./components/authLogin";
import Dashboard from "./components/Dashboard";
// import AuthProvider from "./components/AuthProvider";
import PrivateRoute from "./components/PrivateRoute";
// import { UserProvider } from './contexts/UserContext';


import Index from './components/index'
import Login from './components/login'
import Register from './components/register'
// import UserList from './pages/UserList'
import UserList from './pages/users/UsersList'
import UserDetail from './pages/users/UserDetail'
import PosLayout from  "./components/PosLayout"
import ProductsLayout from  "./components/ProductsLayout"
import Products from "./pages/products";
import CheckOut from './pages/checkout';
import ProductsList from './pages/products/ProductsList'
import ProductDetail from './pages/products/ProductDetail'
import Invoices from './pages/invoices/invoices'
import Stock from './pages/products/stock'
import StockTrans from './pages/products/stockTrans'
import UpdateUser from './api/UpdateUser';
import Test from "./pages/test";
// import { CartsProvider } from './contexts/CartContext';
import CartsCustomer from './pages/cartsCustomer'

import './App.css';


function App() {
  return (
    // <CartsProvider>

      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/cuscart" element={<CartsCustomer />} />
       

        <Route element={<PrivateRoute />} >
          <Route  path="/pos" element={<PosLayout />} >
             {/* <Route  path="/pos" element={<Dashboard />} > */}
             {/* <Route index element={<Products />} /> */}
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="checkout" element={<CheckOut />} />
            <Route path="invoices" element={<Invoices />} />
             {/* <Route path="/pos/allproduct" element={<PosLayout />} /> */}
            <Route path="/pos/products" element={<ProductsLayout />} >
              <Route index element={<Products />} />
              <Route path=":id" element={<Products />} />
                {/* <Route index element={<Products />} />
                <Route path=":id" element={<Products />} /> */}
            </Route>
          </Route>
          <Route path="users" element={<PosLayout />} >
            <Route index element={<UserList />} />
            {/* <Route path="user" element={<UserList />} /> */}
            <Route path=":userid" element={<UserDetail />} />
          </Route>

           <Route path="products" element={<PosLayout />} >
            <Route index element={<ProductsList />} />
            <Route path="stocks" element={<Stock />} />
            <Route path="stocktrans" element={<StockTrans />} />
            {/* <Route path="user" element={<UserList />} /> */}
            <Route path=":productid" element={<ProductDetail />} />
          </Route>
 
        </Route>
            <Route path="addnew" element={<UpdateUser />} />

        <Route path="/test" element={<Test />} />


        {/* <Route  element={<HomeLayout />} >
          <Route path="/home" element={<Home />} />
          <Route path="bill" element={<Bill />} />
        </Route>

        <Route  path="/pos" element={<PosLayout />} >
          <Route index element={<Products />} />
          <Route path="/pos/products">
            <Route index element={<Products />} />
            <Route path=":id" element={<Products />} />
          </Route>
        </Route>

        <Route path="/users" element={<UsersLayout />}>
          <Route path="/users/:id" element={<User />} />
        </Route> */}

      </Routes>  
    // </CartsProvider>      
  );
}

export default App;
